import * as React from 'react';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';

export interface CommonPhrasesProps {
  commonPhrases?: CommonPhraseProps[];
}

export interface CommonPhraseProps {
  text?: string;
}

export const CommonPhrases: React.FunctionComponent<CommonPhrasesProps> = props => {
  const { commonPhrases } = props;

  const formatPhrases = (phrases: CommonPhraseProps[]): string => {
    const commonPhrasesLabels = phrases.slice(0, 3).map(phrase => phrase.text);

    return commonPhrasesLabels.join(', ');
  };

  return (
    <div className="all-t-padding-two all-b-padding-four">
      <UitkLayoutFlex space="two">
        <>
          <UitkLayoutFlexItem>
            <UitkText overflow="truncate">
              <span className="common-phrases-on-top">{formatPhrases(commonPhrases)}</span>
            </UitkText>
          </UitkLayoutFlexItem>
        </>
      </UitkLayoutFlex>
    </div>
  );
};

CommonPhrases.displayName = 'CommonPhrases';
